<template>
	<div>
		<div class="panel questions-search theme-light">
			<div class="container">
				<div class="row align-items-end">
					<!--
					<div class="col-12 col-lg-9 order-lg-1">
						<form action>
							<div class="search-block">
								<b-form-input type="text"></b-form-input>
								<button type="submit" class="search-submit icon-search"></button>
							</div>
						</form>
					</div>
					-->

					<div class="col-12 col-md-6 col-lg-3">
						<div class="drop-selector">
							<client-only>
								<b-dropdown
									variant="selector"
									:text="selectedType"
									@click.native="selectType($event.target)"
								>
									<b-dropdown-item
										v-for="(item, index) in this.block.unique_type_list"
										:key="index"
										:value="item"
									>
										{{ item }}
									</b-dropdown-item>
								</b-dropdown>
							</client-only>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="panel questions-content">
			<div class="container">
				<!-- <div class="row">
					<div class="col-12 col-lg-9 offset-lg-3">
						<h2>Вопросы: Влияние коронавируса на ТЭК</h2>
						<div>
							Все вопросы
						</div>
					</div>

				</div>-->

				<ul class="questions_list">
					<li v-for="(item, index) in filteredList" :key="index" class="row">
						<div class="col-12 col-lg-3">
							<div class="question_author">
								<div class="title">
									{{ item.author }}
								</div>
								<div class="description">
									{{ item.city }}
								</div>
							</div>
						</div>

						<div class="col-12 col-lg-9">
							<div :id="'quest-'+item.fixed_index" class="question_item">
								<div class="theme">
									{{ item.type }}
								</div>
								<div class="title">
									{{ item.question }}
								</div>
								<client-only>
									<b-collapse :id="'q-collapse-' + item.fixed_index" v-html="item.answer" />

									<span class="d-flex justify-content-end">
										<!-- LikeBtn.com BEGIN Важно формировать ID для статьи 	LikeBtn.com END -->
										<span
											class="likebtn-wrapper"
											data-lang="ru"
											data-white_label="true"
											:data-identifier="'item_'+fetchedData.id+'_'+item.fixed_index"
											data-show_dislike_label="true"
											data-site_id="5eb01fe9fa8fdf0a0e33b1ec"
										/>

									</span>
								</client-only>
							</div>
						</div>

						<div class="col-12">
							<div class="question_footer">
								<b-button
									v-b-toggle="'q-collapse-' + item.fixed_index"
									v-b-tooltip.hover
									variant="resize"
									class="icon-chevron"
									title="Открыть ответ"
								/>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
const FILTER_ALL = 'Группы вопросов';
export default {
	name: 'PanelQna',
	props: ['block', 'fetchedData'],
	data() {
		return {
			selectedType: FILTER_ALL,
		};
	},
	computed: {
		filteredList() {
			if (this.selectedType === FILTER_ALL) {
				return this.block.items;
			}
			return this.block.items.filter(
				(p) => p.type === this.selectedType,
			);
		},
	},
	mounted() {
		this.likebtn();
	},
	methods: {
		selectType(target) {
			this.selectedType = target.getAttribute('value');
		},
		likebtn() {
			(function (d, e, s) {
				if (d.getElementById('likebtn_wjs')) return;
				const a = d.createElement(e);
				const m = d.getElementsByTagName(e)[0];
				a.async = 1;
				a.id = 'likebtn_wjs';
				a.src = s;
				m.parentNode.insertBefore(a, m);
			}(document, 'script', '//w.likebtn.com/js/w/widget.js'));
		},
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/layouts/questions-page";
</style>
